import { render } from "./ShareSvg.vue?vue&type=template&id=3b45b4b4"
import script from "./ShareSvg.vue?vue&type=script&lang=js"
export * from "./ShareSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__